import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router";
import {
  getNumberWithUnit,
  VideoModal,
  VideoIframe,
  FundInnerDetails,
  CanCan,
  Permissions,
  CompanyNote,
} from "@hedgefund/shared";
import {
  Button,
  DropDownButton,
  Spinner,
} from "@public/ui-toolkit";
import ScheduleModal from "./components/ScheduleModal";
import { useDispatch, useSelector } from "react-redux";
import {
  getFundManagers,
  getHedgeUserFreeSlots,
  getAllUsers,
  createAppointment,
  createRoom,
  investInFund,
  createNotes,
  getNotes,
  getPerformanceMetricsSearchResult,
  GetRiskReportSearchResult,
  RiskReportSearchResultByMonth,
  CreateAuditLogs,
  GetFCNTenants,
  getAllocatorUsers,
  getHedgeFundDetails,
  getFundDetails,
  getFundBioUsersAction
} from "./actions";
import { followFund } from "../SearchHedgeFund/actions";
import { alertService } from "@hedgefund/shared/src/Alert";
import Stats from "@hedgefund/shared/src/Stats";
import jwtDecode from "jwt-decode";
import FundTearSheet from "@hedgefund/shared/src/FundTearSheet";
import FundRiskReport from "@hedgefund/shared/src/FundRiskReport";
import { Avatar, Col, Drawer, Row, Spin } from "antd";
import FundStatCard from "@hedgefund/shared/src/FundStatCard";
import VerticalButton from "@public/ui-toolkit/src/VerticalButton";

const scheduleMeetingData = [
  { option: "In Person", key: "person" },
  { option: "Virtual Meeting", key: "zoom" },
];

const RoomType = [
  {
    id: 0,
    name: "Private"
  },
  {
    id: 1,
    name: "Group"
  }
]
const HedgeFundDetail = ({ match, location }) => {
  const [modalState, setModalState] = useState();
  const [visibleMeetingModal, setVisibleMeetingModal] = useState(false);
  const [chatLoading, setChatLoading] = useState(false);
  const [userDrawer, setUserDrawer] = useState(false);
  const [fundOverview, setFundOverview] = useState(false);
  const [fundBio, setFundBio] = useState(false);
  const [currentFund, setCurrentFund] = useState(0);


  const { zoom } = location;
  const history = useHistory();
  const dispatch = useDispatch();
  const fundState = useSelector((state) => state.hedgeFundDetailStore);

  const {
    hedgeFund,
    fund,
    fundStats,
    fundId,
    fundManagers,
    users,
    loading,
    monthlyReturnPerformance,
    investBtnLoading,
    riskReportMonthList,
    reportExtractData,
    pmLoading,
    performanceMetrcisMonth,
    notesLoading,
    adminList,
    // fundDecks,
    notes,
    allocatorUsers,
    userLoading,
    fundLoading,
    fundBioUsers,
    bioLoading,
  } = fundState;
  const items = [
    {
      id: "0",
      fullName: hedgeFund?.name,
      profileUrl: hedgeFund?.logo,
      title: "HedgeFund Chat",
    },
    ...allocatorUsers
  ];
  const [followFunds, setFollowFunds] = useState(false);
  const hedgeFundId = match.params.id;
  const fundUrlId = match.params.fundId;
  const targetDivRef = useRef(null);

  const scrollToDiv = () => {
    if (targetDivRef.current) {
      targetDivRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    setTimeout(() => {
      if (zoom) {
        let elementId = `${zoom}-Virtual Meeting`;
        let element = document.getElementById(elementId);
        element?.click();
      }
    }, 2000);
  }, [zoom]);

  useEffect(() => {
    if (hedgeFundId) {
      dispatch(getHedgeFundDetails(hedgeFundId));
    }
    dispatch(getAllUsers());
    dispatch(GetFCNTenants());
  }, [hedgeFundId]);

  useEffect(() => {
    if (Boolean(Object.keys(hedgeFund))) {
      if (hedgeFund) {
        setFollowFunds(fundStats[0]?.followed);
        if (Object.keys(fund).length !== 0) {
          const values = {
            actionName: "View Fund Detail",
            parameters: { hedgeFundId: hedgeFundId, Name: fund?.name }
          }
          onCreateAuditLogs(values);
        }
      }
    }
  }, [hedgeFund]);

  useEffect(() => {
    if (fundId) {
      dispatch(GetRiskReportSearchResult({ id: fundId }));
      dispatch(getNotes(fundId));
    }
    if (fundUrlId) {
      setCurrentFund(fundUrlId);
    } else {
      setCurrentFund(fundId);
    }
  }, [fundUrlId, fundId]);

  const handleYearChange = (presentYear) => {
    dispatch(getPerformanceMetricsSearchResult({ id: fundId, year: presentYear }));
  };

  const handleReportChange = (riskReport) => {
    dispatch(RiskReportSearchResultByMonth(riskReport));
  };

  const freeSlots = useSelector((state) =>
    state.fundDetail?.freeSlots?.map(({ slotStart, slotEnd }) => {
      const start = slotStart.split(":");
      const end = slotEnd.split(":");
      return {
        slotStart: start[0] + ":" + start[1],
        slotEnd: end[0] + ":" + end[1],
      };
    })
  );

  const getFreeSlots = (values) => {
    dispatch(getHedgeUserFreeSlots(values));
  };
  const newAppointment = (data, onSuccess) => {
    if (modalState === "zoom") {
      const newData = { ...data, Type: 0 };
      const values = {
        actionName: "Schedule Virtual Appointment",
        parameters: newData
      }
      onCreateAuditLogs(values);
      dispatch(createAppointment(newData, onSuccess));
    }
    if (modalState === "person") {
      const newData = { ...data, Type: 1 };
      const values = {
        actionName: "Schedule In Person Appointment",
        parameters: newData
      }
      onCreateAuditLogs(values);
      dispatch(createAppointment(newData, onSuccess));
    }
  };

  const onSuccess = () => {
    setFollowFunds(!followFunds);
  };

  const onClickFollowFundHandler = () => {
    const values = {
      actionName: "Start Following Fund",
      parameters: { fundName: fund?.name }
    }
    onCreateAuditLogs(values);
    dispatch(followFund(fund.id, !followFunds, onSuccess));
    setFollowFunds(!followFunds);
  };

  const onSuccessAlert = () => {
    alertService.success("Successfully Created!", { autoClose: true });
  };

  const onSubmitNotes = (values, onCloseModal) => {
    const value = {
      actionName: "Add Note",
      parameters: { title: values.title }
    }
    onCreateAuditLogs(value);
    dispatch(createNotes(values, onSuccessAlert, onCloseModal));
  };
  const onCreateAuditLogs = (values) => {
    const user = jwtDecode(sessionStorage.getItem("token") ?? localStorage.getItem("token"));
    const auditLog = {
      userId: user?.UserId,
      userName: user?.["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"],
      tenantId: user?.["http://www.aspnetboilerplate.com/identity/claims/tenantId"],
      tenantName: user.TenantName,
      entityId: fundId,
      entityName: fund.name,
      entityType: "Allocator",
      timeStamp: new Date(),
      ownerId: hedgeFund?.id,
      ownerName: hedgeFund?.name,
      actionName: values.actionName,
      parameters: JSON.stringify(values.parameters)
    }
    if (!sessionStorage.getItem("token") || user.TenantName !== window._env_.RESTRICTED_COMPANY) {
      dispatch(
        CreateAuditLogs(auditLog)
      );
    }
  }
  const submitNotesHandler = (notesData, onCloseModal) => {
    onSubmitNotes(notesData, onCloseModal);
  };

  const joinChatRoom = (body) => {
    setChatLoading(true);
    const values = {
      actionName: "Initiate Chat",
      parameters: body
    }
    onCreateAuditLogs(values);
    dispatch(
      createRoom(body, (roomId) => {
        setChatLoading(false);
        history.push(`/chat?identifier=${roomId}&type=1`);
      })
    );
  }

  const onChatClickHandler = (key) => {
    const body = {
      tenantId: hedgeFund?.id,
      type: key === "0" ? RoomType[1].id : RoomType[0].id,
      ...(key !== "0" && { userId: key }),
    };
    joinChatRoom(body);
  }
  const onFundDetail = (id) => {
    dispatch(getFundDetails(id, setFollowFunds));
  }
  return (
    (chatLoading === true) ?
      (<main className="main-doc">
        <div className="main-inner">
          <Row>
            <Col span={24} style={{ textAlign: "center" }}>
              <Spin />
            </Col>
          </Row>
        </div>
      </main>)
      :
      (<main>
        <div className="main-inner">
          <div className="mt-3">
            {fundState.loading || !Object.keys(hedgeFund)?.length ? (
              <Spinner />
            ) : (
              <Row gutter={16} style={{ margin: "auto" }}>
                {/* Side Nav Bar */}
                <Col span={6} className="gutter-row" offset={1} style={{ backgroundColor: "#fff", borderRadius: "10px", border: "1px solid #edeef0" }}>
                  <div className="position-fixed" style={{ width: "25%" }} >
                    <Row>
                      <Col span={24}>
                        <img
                          className="logo-style"
                          src={hedgeFund?.logo ?
                            hedgeFund?.logo
                            : "/assets/images/bg1.png"
                          }
                          alt="Company Logo"
                        />
                        {/* <Col span={24}>
                      <img className="hedge-Fund-Card" src={hedgeFund?.logo ? hedgeFund?.logo : "/assets/images/bg1.png"} alt="Profile Image" />
                    </Col> */}
                      </Col>
                      <Col>
                        <Row>
                          <Col span={24} className="text-center mt-3">
                            <div className="Fund-FontSize" style={{ fontSize: "26px" }}>{hedgeFund?.name}</div>
                            <h4 className="ml-4" style={{ width: "85%" }}>{hedgeFund?.address}</h4>
                          </Col>
                          <Col span={23} offset={1} className="text-center mt-3">
                            <CanCan permissionName={Permissions?.CHAT_INITIATE?.name}>
                              <VerticalButton
                                btnName={"Chat"}
                                iconClass="fa fa-comments mr-1"
                                btnType="primary"
                                onClick={() => {
                                  dispatch(getAllocatorUsers(hedgeFund?.id));
                                  setUserDrawer(true);
                                }}
                              />
                            </CanCan>
                            <CanCan permissionName={Permissions?.MEETING_SCHEDULE?.name} >
                              <DropDownButton
                                modal="modal"
                                modalid="#scheduleMeeting"
                                iconClass="fa fa-calendar mr-1"
                                dropDownBtnName="Schedule"
                                dropDownBtnList={scheduleMeetingData}
                                setScheduleType={(type) => {
                                  setModalState(type);
                                  dispatch(getFundManagers(fundId));
                                  setVisibleMeetingModal(true);
                                }}
                              />
                            </CanCan>


                          </Col>
                          <hr style={{ fontSize: "5px", marginLeft: "15px", marginRight: "15px" }} />
                          <Col span={24}>
                            <FundInnerDetails
                              strategyValue={fund?.strategyName}
                              subSpecialities={fund?.subSpecialtyName}
                              aumValue={getNumberWithUnit(hedgeFund?.aum)}

                            />
                          </Col>
                          <hr style={{ fontSize: "5px", marginLeft: "15px", marginRight: "15px" }} />
                          <Col span={24} >
                            <Stats
                              fundName={fund?.name}
                              ytdValue={fundId === window._env_.EthosFundId ? `${fund?.ytd}%**` : `${fund?.ytd}%`}
                              latestMonthValue={`${fund?.monthlyReturn}%`}
                              annualReturnsValue={fundId === window._env_.EthosFundId ? "" : `${fund?.annualizedReturn}%`}
                              annualVolatilityValue={fundId === window._env_.EthosFundId ? "" : `${fund?.annualVolatility}%`}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </Col>

                <Col span={16} className="gutter-row">
                  {!fundLoading ? (
                    <>
                      {fundStats?.length > 1 && (
                        <FundStatCard
                          funds={fundStats}
                          id={fundId}
                          notes={fund?.note}
                          currentFund={currentFund}
                          setCurrentFund={setCurrentFund}
                          onClick={onFundDetail}
                        />
                      )}

                      <Row>
                        <Col span={24} style={{ backgroundColor: "#276598", padding: "15px 25px", borderRadius: "4px" }} className="mt-2" >
                          <div className="Fund-FontSize" style={{ color: "#fff", margin: "0px", fontSize: "26px" }}>Fund: {fund?.name}</div>
                        </Col>
                      </Row>

                      <Row>
                        <Col span={24} className="mt-2" style={{ textAlign: "end", backgroundColor: "#fff", padding: "10px 5px", position: "relative", borderRadius: "10px" }}>
                          <span>
                            <CanCan permissionName={Permissions?.FUND_FOLLOW?.name}>
                              <Button
                                btnName={followFunds ? "Followed" : " Follow"}
                                btnType="!primary"
                                iconClass="fa fa-check-square mr-1"
                                onClick={onClickFollowFundHandler}
                                disabled={fund?.invested}
                              />
                            </CanCan>
                            <CanCan permissionName={Permissions?.FUND_INVEST?.name}>
                              <Button
                                loading={investBtnLoading}
                                btnName={
                                  fund?.invested
                                    ? "Added To My Funds"
                                    : " Add To My Funds"
                                }
                                iconClass="fa fa-usd mr-1"
                                disabled={fund?.invested}
                                btnType="!primary"
                                onClick={() => {
                                  const value = {
                                    actionName: "Add into My Funds",
                                    parameters: { fundId: fundId }
                                  }
                                  onCreateAuditLogs(value);
                                  dispatch(investInFund({ fundId }))
                                }
                                }
                              />
                            </CanCan>
                            <Button
                              btnName={"Fund Overview"}
                              iconClass="fa fa-file mr-1"
                              btnType="primary"
                              onClick={() => {
                                setFundOverview(!fundOverview);
                              }}
                            />
                            <Button
                              btnName={"Fund Bios"}
                              iconClass="fa fa-file-text mr-1"
                              btnType="primary"
                              onClick={() => {
                                dispatch(getFundBioUsersAction(hedgeFundId));
                                setFundBio(true);
                              }}
                            />
                            <Button
                              btnName={"Fund Compare"}
                              iconClass="fa fa-balance-scale mr-1"
                              btnType="primary"
                              onClick={() => history.push("/comparefund/" + fundId)}
                            />
                            {fund?.invested ? (
                              <Button
                                btnName="Docs"
                                iconClass="fa fa-pencil-square-o mr-1"
                                btnType="primary"
                                onClick={() =>
                                  history.push(
                                    `/document/${fund?.fundInvestorId === null
                                      ? fund.selectedId
                                      : fund.fundInvestorId
                                    }`
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                            <Button
                              btnName={"Allocator Notes"}
                              iconClass="fa fa-file-text mr-1"
                              btnType="primary"
                              onClick={scrollToDiv}
                            />
                            <Button
                              btnType="primary"
                              iconClass="fa fa-cloud mr-1"
                              btnName={"Cloud Document"}
                              onClick={() => history.push(`/cloud-document/${hedgeFund?.id}`)}
                            />
                          </span>
                        </Col>
                        {fund?.note !== null ? (
                          <Col span={24} className="sticky mt-2">
                            <h4>{"Additional Information"} : </h4>
                            <p>{fund?.note}</p>
                          </Col>
                        ) : ""}
                        {fundOverview && (
                          <Col span={24} className={`sticky expandable ${fundOverview}-animation mt-2`}>
                            <h4>{"Fund Overview"} : </h4>
                            <p dangerouslySetInnerHTML={{ __html: fund?.description ? fund?.description : "N/A" }} />
                          </Col>
                        )}
                      </Row>

                      {/* Media Section  */}
                      <Row className="component mt-3">
                        <Col span={24} className="component-header">
                          <div className="Fund-FontSize" style={{ fontSize: "26px" }}>{hedgeFund?.name} Media</div>
                        </Col>
                        <Col span={24} className="component-body">
                          <VideoModal myFundDetails={hedgeFund} onCreateAuditLogs={onCreateAuditLogs} />
                        </Col>
                      </Row>

                      {/* Tear Sheet Section  */}

                      <FundTearSheet
                        fundId={fundId}
                        fund={fund}
                        onCreateAuditLogs={onCreateAuditLogs}
                        handleYearChange={handleYearChange}
                        getPerformanceMetricsSearchResult={getPerformanceMetricsSearchResult}
                        performanceMetrcisMonth={performanceMetrcisMonth}
                        monthlyReturnPerformance={monthlyReturnPerformance}
                        loading={loading}
                      />

                      <FundRiskReport
                        fundId={fundId}
                        fund={fund}
                        onCreateAuditLogs={onCreateAuditLogs}
                        reportExtractData={reportExtractData}
                        riskReportMonthList={riskReportMonthList}
                        handleReportChange={handleReportChange}
                        pmLoading={pmLoading}
                      />
                      {/* Allocator Notes Section */}
                      <CompanyNote
                        id={fundId}
                        getNotes={notes}
                        onSubmitNote={submitNotesHandler}
                        loading={notesLoading}
                        targetDivRef= {targetDivRef}
                        />
                      {/* Document Cloud Section */}
                      {/* <FundDeck
                        fundname={fund?.name}
                        onCreateAuditLogs={onCreateAuditLogs}
                        decks={fundDecks}
                      /> */}

                    </>) : (
                    <Row style={{ textAlign: "center" }}>
                      <Col span={24} >
                        <Spinner />
                      </Col>
                    </Row>)}
                </Col>
              </Row>
            )}
          </div>
        </div>
        {/* <NotesModal
          id={fundId}
          onSubmitNotes={onSubmitNotes}
          notesLoading={notesLoading}
        /> */}
        <Drawer title="Fund Bio's" open={fundBio} onClose={() => setFundBio(false)} width={500}  >
          <Row>
            <Col span={24} className="mt-2 bg-light">
              {!bioLoading ? (
                fundBioUsers?.map((user) => {
                  return (
                    <Row style={{ margin: "5px 0px", borderLeft: "3px solid #9f9f9f" }}>
                      <Col span={4} className="text-center">
                        <Avatar src={user?.profileImage} style={{ height: "50px", width: '50px' }} size={"large"} />
                      </Col>
                      <Col span={19} >
                        <Row>
                          <Col span={24} >
                            <span className="font-weight-bold"> {user?.fullName} </span>
                          </Col>
                          <span className="text-secondary" style={{ fontSize: "11px" }}> {user?.title}</span>

                          <Col span={24}>
                            <p dangerouslySetInnerHTML={{ __html: user?.highlight ? user?.highlight : "N/A" }} />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  )
                })
              ) : (
                <Spinner />
              )}
            </Col>
          </Row>
        </Drawer>
        <Drawer title="HedgeFund User" open={userDrawer} onClose={() => setUserDrawer(false)}  >
          <Row className="mt-3" style={{ backgroundColor: "rgb(245 245 245)", padding: "10px" }}>
            {!userLoading ? (
              items?.map((item) => {
                return (
                  <Col span={24}>
                    <Row onClick={() => onChatClickHandler(item?.id)}>
                      <Col span={7}>
                        <Avatar src={item?.profileUrl} style={{ height: "70px", width: '70px' }} size={"large"} />
                      </Col>
                      <Col span={17}>
                        <Row style={{ cursor: "pointer" }}>
                          <Col span={24} style={{ color: "#3ac1b5" }}>
                            {item?.fullName}
                          </Col>
                          <Col span={24}>{item?.title ? item?.title : "N/A"}</Col>
                        </Row>
                      </Col>
                    </Row>
                    <hr style={{ fontSize: "5px", marginLeft: "15px", marginRight: "15px" }} />
                  </Col>
                )
              })
            ) : (
              <Spinner />
            )}
          </Row>
        </Drawer>
        <ScheduleModal
          fundManagers={fundManagers}
          name={hedgeFund.name}
          getSlots={getFreeSlots}
          freeSlots={freeSlots}
          admin={adminList}
          users={users}
          // fundId={fundId}
          hedgeFundId={hedgeFund?.id}
          newAppointment={newAppointment}
          loading={loading}
          title={
            modalState === "zoom"
              ? " Schedule a FCN Virtual Meeting"
              : " Schedule a In Person Meeting"
          }
          Visible={visibleMeetingModal}
          setVisibility={setVisibleMeetingModal}
        />
        <div></div>
        <VideoIframe myFundDetails={hedgeFund} />
      </main>)
  );
};

export default HedgeFundDetail;